import { render } from "./primaryButtonComponent.vue?vue&type=template&id=91c8e8be&scoped=true"
import script from "./primaryButtonComponent.vue?vue&type=script&lang=js"
export * from "./primaryButtonComponent.vue?vue&type=script&lang=js"

import "./primaryButtonComponent.vue?vue&type=style&index=0&id=91c8e8be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c8e8be"]])

export default __exports__